import React, { Component } from 'react';
import CONNECT from '../redux/connect';
import Body from './reuseable/Body';
// import Header from './reuseable/Header';

class Register extends Component {
    constructor(props) {
        super(props);
        this.state = {

        }
    }
    componentDidMount() {
        this.props.setHeader('type','daftar');
    }
    render() {
        return (
            <>
                {/* <Header refact={true} /> */}
                <Body {...this.props} />
            </>
        )
    }
}
export default CONNECT(Register);